import PrinterService from '@/services/PrinterService.js'
export const namespaced = true

export const state = {
  printers: [],
  isFetchingPrinters: false,
  printObject: null,
  showDialog: false,
  htmlReceipt: '',
  isLoadingUnassignWorkstationPrinterIds: [],
  isLoadingAssignWorkstationPrinterIds: [],
  isDeletingPrinterIds: []
}

export const mutations = {
  SET_PRINTERS (state, val) {
    state.printers = val
  },
  SET_IS_FETCHING_PRINTERS (state, val) {
    state.isFetchingPrinters = val
  },
  SET_HTML_RECEIPT (state, val) {
    state.htmlReceipt = val
  },
  SET_SHOW_DIALOG (state, val) {
    state.showDialog = val
  },
  SET_IS_LOADING_ASSIGN_WORKSTATION (state, { printerId, val }) {
    if (val) {
      const i = state.isLoadingAssignWorkstationPrinterIds.findIndex(id => id === printerId)
      if (i < 0) {
        state.isLoadingAssignWorkstationPrinterIds.push(printerId)
      }
    } else {
      const i = state.isLoadingAssignWorkstationPrinterIds.findIndex(id => id === printerId)
      state.isLoadingAssignWorkstationPrinterIds.splice(i, 1)
    }
  },
  SET_IS_LOADING_UNASSIGN_WORKSTATION (state, { printerId, val }) {
    if (val) {
      const i = state.isLoadingUnassignWorkstationPrinterIds.findIndex(id => id === printerId)
      if (i < 0) {
        state.isLoadingUnassignWorkstationPrinterIds.push(printerId)
      }
    } else {
      const i = state.isLoadingUnassignWorkstationPrinterIds.findIndex(id => id === printerId)
      state.isLoadingUnassignWorkstationPrinterIds.splice(i, 1)
    }
  },
  SET_IS_DELETING_PRINTER (state, { printerId, val }) {
    if (val) {
      const i = state.isDeletingPrinterIds.findIndex(id => id === printerId)
      if (i < 0) {
        state.isDeletingPrinterIds.push(printerId)
      }
    } else {
      const i = state.isDeletingPrinterIds.findIndex(id => id === printerId)
      state.isDeletingPrinterIds.splice(i, 1)
    }
  }
}

export const actions = {
  fetchPrinters ({ commit }) {
    commit('SET_IS_FETCHING_PRINTERS', true)
    commit('SET_PRINTERS', [])

    return PrinterService.getPrinters()
      .then(({ data }) => {
        if (data.status === 'success') {
          commit('SET_PRINTERS', data.data.printers)
        }
      })
      .finally(() => {
        commit('SET_IS_FETCHING_PRINTERS', false)
      })
  },
  showPrint ({ commit }, print) {
    const printer = new Printer(print)
    commit('SET_HTML_RECEIPT', printer.html(42))
    commit('SET_SHOW_DIALOG', true)
  },
  async print ({ dispatch, rootState }, print) {
    const defaultPrinter = rootState.workstation?.default_printer
    if (!print.port) {
      print.port = defaultPrinter?.port ?? 'SIM'
    }
    if (!print.width) {
      print.width = defaultPrinter?.width ?? 42
    }
    if (!print.type) {
      print.type = defaultPrinter?.protocol ?? 'epson'
    }
    if (print.type === 'star') {
      print.width = 48
    }

    if (print.port === 'SIM') {
      dispatch('showPrint', print)
      return 'success'
    } else if (print.port === 'SURF') {
      const content = print.content
      const printerId = rootState.workstation?.default_printer?.id
      if (!printerId) {
        console.log(`Försökte skriva ut på port "${print.port}" men ingen default printer är tilldelad denna enhet`)
        return 'error'
      }
      const result = await PrinterService.printOnSurfboard({ printerId, content })
        .then(({ data }) => {
          return data?.status
        })
      return result
    } else if (!window.printer) {
      // Nedan cases kräver window.printer
      return 'error'
    } else if (print.port === 'WIN' || print.port === 'WINDOWS') {
      const printer = new Printer(print)
      const html = printer.html(print.width)
      await window.printer.printOnWindows(html)
      return 'success' // Tror inte kan få resultat på detta på enkelt sätt
    } else {
      const result = await window.printer.printObject(print)
      return result
    }
  },
  printTestPage ({ dispatch }, { port, type = 'epson', width = 48 }) {
    const printObject = {
      content: [],
      port,
      type,
      width
    }
    printObject.content.push({
      type: 'newline'
    })
    printObject.content.push({
      type: 'newline'
    })
    printObject.content.push({
      type: 'text',
      alignment: 'center',
      value: 'Din port är',
      text_size: 1,
      bold: false
    })
    printObject.content.push({
      type: 'text',
      alignment: 'center',
      value: port,
      text_size: 2,
      bold: false
    })
    printObject.content.push({
      type: 'newline'
    })
    printObject.content.push({
      type: 'newline'
    })
    printObject.content.push({
      type: 'text',
      value: '42 tecken linje',
      text_size: 0,
      alignment: 'left',
      bold: false
    })
    printObject.content.push({
      type: 'text',
      value: '------------------------------------------',
      text_size: 0,
      alignment: 'left',
      bold: false
    })
    printObject.content.push({
      type: 'newline'
    })
    printObject.content.push({
      type: 'newline'
    })
    printObject.content.push({
      type: 'text',
      value: '48 tecken linje',
      text_size: 0,
      alignment: 'left',
      bold: false
    })
    printObject.content.push({
      type: 'text',
      value: '------------------------------------------------',
      text_size: 0,
      alignment: 'left',
      bold: false
    })
    printObject.content.push({
      type: 'newline'
    })
    printObject.content.push({
      type: 'newline'
    })
    printObject.content.push({
      type: 'text',
      value: 'Testar svenska tecken:',
      text_size: 0,
      alignment: 'left',
      bold: false
    })
    printObject.content.push({
      type: 'text',
      value: 'åäö ÅÄÖ',
      text_size: 0,
      alignment: 'left',
      bold: false
    })
    printObject.content.push({
      type: 'newline'
    })
    printObject.content.push({
      type: 'newline'
    })
    printObject.content.push({
      type: 'cut'
    })
    dispatch('print', printObject)
  },
  printBong ({ dispatch, rootState }, { printerId, print }) {
    if (!rootState.workstation || rootState.workstation.printers.length === 0) {
      return false
    }
    const printer = rootState.workstation.printers.find(p => p.id === printerId)
    if (!printer) {
      return false
    }
    print.port = printer.port
    print.type = printer.protocol ?? print.type ?? 'epson'
    print.width = print.type === 'star' ? 48 : printer.width
    if (print.port === 'SIM') {
      dispatch('showPrint', print)
    } else if (!window.printer) {
      return false
    } else if (print.port === 'WINDOWS' || print.port === 'WIN') {
      const printer = new Printer(print)
      const html = printer.html(print.width)
      window.printer.printOnWindows(html)
    } else {
      window.printer.printObject(print)
    }
  },
  assignThisWorkstationToPrinter ({ commit, dispatch, rootState }, { printerId }) {
    commit('SET_IS_LOADING_ASSIGN_WORKSTATION', { printerId, val: true })
    const workstationId = rootState.workstation.id

    PrinterService.assignPrinter({ printerId, workstationId })
      .then(({ data }) => {
        if (data.status === 'success') {
          commit('SET_PRINTERS', data.data.printers)
          // hämta om kassaenheterna också?
          // dispatch('posRegister/fetchUnits', undefined, { root: true })
          dispatch('snackbars/createSnackbar', {
            color: 'success',
            text: 'Kvittoskrivaren har tilldelats den här enheten'
          }, { root: true })
        }
      })
      .finally(() => {
        commit('SET_IS_LOADING_ASSIGN_WORKSTATION', { printerId, val: false })
      })
  },
  unassignWorkstationFromPrinter ({ commit, dispatch }, { printerId }) {
    commit('SET_IS_LOADING_UNASSIGN_WORKSTATION', { printerId, val: true })
    PrinterService.assignPrinter({ printerId, workstationId: null })
      .then(({ data }) => {
        if (data.status === 'success') {
          commit('SET_PRINTERS', data.data.printers)
          // hämtar om kassaenheter?
          // dispatch('posRegister/fetchUnits', undefined, { root: true })
          dispatch('snackbars/createSnackbar', {
            color: 'success',
            text: 'Kvittoskrivaren har kopplats bort från enheten'
          }, { root: true })
        }
      })
      .finally(() => {
        commit('SET_IS_LOADING_UNASSIGN_WORKSTATION', { printerId, val: false })
      })
  },
  deletePrinter ({ commit }, { printerId }) {
    commit('SET_IS_DELETING_PRINTER', { printerId, val: true })
    return PrinterService.deletePrinter({ printerId })
      .then(({ data }) => {
        if (data.status === 'success') {
          commit('SET_PRINTERS', data.data.printers)
        }
      })
      .finally(() => {
        commit('SET_IS_DELETING_PRINTER', { printerId, val: false })
      })
  }
}

export const getters = {
  hasPrinter: function (state, getters, rootState) {
    return !!rootState.workstation?.default_printer
  }
}

class Printer {
  constructor (printObject) {
    this.printObject = printObject
  }

  html (width = 42) {
    this.width = width
    // width: 80mm; width: 72mm;
    this.print = `<div style="all:initial;">
      <div class="paper" style="width: ${this.width * 1.1}ch; max-width: ${this.width * 1.1}ch; font-family: 'Consolas', monospace; font-size: 3mm; margin: auto; overflow: hidden; filter: grayscale(100%);">
        <div class="printarea" style="width: ${this.width}ch; max-width: ${this.width}ch; font-family: 'Consolas', monospace; font-size: 3mm; word-wrap: break-word; overflow-wrap: break-word; word-break: break-all; margin: auto; overflow: hidden;">`
    this.currentAlignment = 'LEFT'
    this.isBold = false
    this.isQuad = false

    for (let i = 0; i < this.printObject.content.length; i++) {
      const line = this.printObject.content[i]
      switch (line.alignment) {
        case 'center':
          this.alignCenter()
          break
        case 'left':
          this.alignLeft()
          break
        case 'right':
          this.alignRight()
          break
        default:
          this.alignLeft()
          break
      }

      if (line.bold) {
        this.bold(true)
      } else {
        this.bold(false)
      }

      if ([0, 1, 2, 3, 4, 5, 6, 7].includes(line.text_size)) {
        this.setTextSize(line.text_size, line.text_size)
      } else {
        this.setTextSize(0, 0)
      }
      switch (line.type) {
        case 'image':
          this.printImage(line.value)
          break
        case 'text':
          this.println(line.value)
          break
        case 'left-right':
          // Anteckning: Left right fungerar bara med textstorlek 0 eller normal
          this.leftRight(line.value[0], line.value[1])
          break
        case 'newline':
          this.newLine()
          break
        case 'line':
          this.drawLine()
          break
        case 'table':
          line.value.forEach(row => {
            this.tableCustom(row)
          })
          break
        case 'open-cash-drawer':
          this.openCashDrawer()
          break
        case 'signal-buzzer':
          this.beep()
          break
        case 'cut':
          this.cut()
          break
      }
    };

    this.print += '</div></div></div>'
    return this.print
  }

  println (value) {
    value = this.replaceSpaces(value)
    let style = ''
    if (this.isBold) {
      style += 'font-weight: bold;'
    }
    if (this.isQuad) {
      style += 'max-width: 21ch; zoom: 200%;'
    }

    if (this.currentAlignment === 'CENTER') {
      style += 'text-align: center;'
    } else if (this.currentAlignment === 'LEFT') {
      style += 'text-align: left;'
    } else if (this.currentAlignment === 'RIGHT') {
      style += 'text-align: right;'
    }
    if (value === '' || value === ' ') {
      value = '<br>'
    }

    this.print += `<div style="${style}">${value}</div>`
  }

  leftRight (left, right) {
    left = this.replaceSpaces(left)
    right = this.replaceSpaces(right)
    let style = "width: 100%; font-family: 'Consolas', monospace; font-size: 3mm; word-wrap: break-word; overflow-wrap: break-word; word-break: break-word; border-spacing: 0px;"
    if (this.isBold) {
      style += 'font-weight: bold;'
    }
    if (this.isQuad) {
      style += 'max-width: 21ch; zoom: 200%;'
    }
    this.print += `<table style="${style}">`
    this.print += `<tr><td style="text-align: left; padding-left: 0px; margin-left: 0px;">${left}</td>
      <td style="text-align: right; padding-left: 0px; margin-left: 0px;">${right}</td></tr></table>`
  }

  printImage (image) {
    const remoteUrl = `https://assets.campingonline.se/printer/${image}`
    this.print += `<div style="width: 100%; display: flex;"><img src="${remoteUrl}" style="max-width: 80%; margin: auto;"></div>`
  }

  tableCustom (table) {
    this.print += '<table style="width: 100%; font-family: Consolas, monospace; font-size: 3mm; word-wrap: break-word; overflow-wrap: break-word; word-break: break-word; border-spacing: 0px;"><tr>'
    table.forEach((row) => {
      this.print += `<td width="${row.width * 100}%" style="text-align: ${row.align}; padding-left: 0px; margin-left: 0px;">${row.text}</td>`
    })
    this.print += '</tr></table>'
  }

  drawLine () {
    this.print += '<div>'
    for (let i = 1; i <= this.width; i++) {
      this.print += '-'
    }
    this.print += '</div>'
  }

  newLine () {
    this.print += '<br>'
  }

  bold (value) {
    this.isBold = value
  }

  alignRight () {
    this.currentAlignment = 'RIGHT'
  }

  alignLeft () {
    this.currentAlignment = 'LEFT'
  }

  alignCenter () {
    this.currentAlignment = 'CENTER'
  }

  setTextQuadArea () {
    this.isQuad = true
  }

  setTextSize (a, b) {
    if (a === 0) {
      this.isQuad = false
    } else {
      this.isQuad = true
    }
  }

  setTextNormal () {
    this.isQuad = false
  }

  cut () {
    this.print += '<div class="cut"></div>'
  }

  openCashDrawer () {
    return 0
  }

  beep () {
    return 0
  }

  replaceSpaces = (str) => {
    str = '' + str // castar till string
    return str.replace(/ /g, '&nbsp;')
  }
}
